import React, { useState, useEffect } from 'react';

import useLayoutHeights from 'views/rebranded-module/common/hooks/UseLayoutHeight';
import StyledButton from 'views/rebranded-module/common/components/UI/ReservationFloatingButtonV2/ReservationFloatingButtonV2.styles';
import { RiAddFill } from 'react-icons/ri';
import { Typography } from '@mui/material';

const ReservationFloatingButtonV2 = (props) => {
  const {
    className, text, handleClick, staticButton = false,
  } = props;
  const { LAYOUT_HEIGHT } = useLayoutHeights(); // Get layout height value
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollCheck = window.scrollY;
      setScroll(scrollCheck);
    };
    document.addEventListener('scroll', onScroll);
    return () => {
      document.removeEventListener('scroll', onScroll);
    };
  }, [scroll, setScroll]);
  return (
    <StyledButton
      scroll={scroll}
      variant="contained"
      size="large"
      id="floatingButton"
      className={`${
        staticButton
          ? 'staticReservationFloatingButton'
          : 'reservationFloatingButton'
      } ${className}`}
      layoutHeight={LAYOUT_HEIGHT}
      onClick={handleClick}>
      <Typography className="RFBV2Text">{text}</Typography>
      <RiAddFill size={16} className="RFBV2AddIcon" />
    </StyledButton>
  );
};
export { ReservationFloatingButtonV2 };
